import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useState } from 'react';
import { Card, CardProps, FormControl } from 'react-bootstrap';
import Button from '../Button';

export type EditableAvatarProps = CardProps &
  React.PropsWithChildren<{
    size?: 'small' | 'large';
    defaultAvatar?: string;
    variant?: 'editable' | 'static';
    name?: string;
  }>;

const EditableAvatar = ({
  size = 'small',
  defaultAvatar,
  variant = 'editable',
  children,
  name,
  ...props
}: EditableAvatarProps) => {
  const [img, setImg] = useState<string | undefined>(defaultAvatar);
  const hiddenFileInput = React.useRef<HTMLInputElement>(null);

  const handleChange = () => {
    if (hiddenFileInput && hiddenFileInput.current) {
      hiddenFileInput.current.click();
    }
  };

  const handleRemove = () => {
    if (hiddenFileInput && hiddenFileInput.current) {
      setImg(undefined);
    }
  };

  const onImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileUploaded = e.target!.files?.[0];

    if (fileUploaded) {
      setImg(URL.createObjectURL(fileUploaded));
    }
  };

  return (
    <Card
      bsPrefix={`cnd-editable-avatar d-flex align-items-center ${
        img !== undefined ? 'changed' : ''
      } ${size === 'large' ? 'large' : ''}`}
      bg={variant}
      {...props}
    >
      <FormControl
        type={'file'}
        onChange={onImageChange}
        ref={hiddenFileInput}
        style={{ display: 'none' }}
      />
      <div
        className={`outer-wrapper ${
          size === 'large' ? 'outer-wrapper-lg' : ''
        }`}
      >
        <div
          className={
            'circle-icon d-flex justify-content-center align-items-center'
          }
          style={{ zIndex: 1 }}
        >
          <FontAwesomeIcon onClick={handleChange} icon={light('camera')} />
        </div>
        <div
          className={
            'image-wrapper d-flex justify-content-center position-relative'
          }
        >
          {img === undefined && name ? (
            <span className={'no-img large w-100 h-100'}>
              {`${name?.charAt(0) || ''}${name?.split(' ')[1][0] || ''}`}
            </span>
          ) : (
            <Card.Img
              src={img}
              className={`${img === undefined ? 'd-none' : 'd-block'}`}
            />
          )}
        </div>
      </div>
      <Card.Body className={'p-0'}>
        <div className={'d-flex flex-column align-items-start'}>
          {variant === 'editable' ? (
            <Fragment>
              <Button variant="primary" onClick={handleChange}>
                {!img ? 'Add Photo' : 'Change Photo'}
              </Button>
              {!!img ? (
                <Button
                  variant="primary-outline"
                  className={'mt-7'}
                  onClick={handleRemove}
                >
                  Remove Photo
                </Button>
              ) : null}
            </Fragment>
          ) : (
            children
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default EditableAvatar;
